import { addDays, eachDayOfInterval, format, parse } from "date-fns";
import React, { useCallback } from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import OrderSummaryItems from "../../../Common/Components/OrderSummaryItems";
import TotalPriceCard from "../../../Common/Components/SummaryTotalPriceCard";
import { TitleHeader } from "../../../Common/Components/TitleHeader";
import useCartTotal from "../../../Common/Hooks/useCartTotal";
import { fetchServices } from "../../../Services/CartService";
import { fetchWeekDaysOff } from "../../../Services/OrderService";
import { DatePicker } from "../../Components/DatePicker";
import {
  fetchOrderDetails as fetchAdminOrderDetails,
  fetchCoupon,
} from "../../Services/OrderService";

export const OrderSummary = () => {
  const [amount] = useCartTotal();
  const bookingType = useSelector((x) => x.BookingType);
  const orderTypeId = useSelector((x) => x.OrderTypeId);
  const deliveryTypes = useSelector((x) => x.OrderTypes);
  const cart = useSelector((x) => x.Cart);
  const coupon = useSelector((x) => x.Coupon);
  const pickupDate = useSelector((x) => x.PickupDate);
  const deliveryDate = useSelector((x) => x.DeliveryDate);
  const note = useSelector((x) => x.Note);
  const addresses = useSelector((x) => x.Addresses);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = React.useState(false);
  const [deliveryType, setDeliveryType] = React.useState(null);
  const [showPickup, setShowPickup] = React.useState(false);
  const [showDelivery, setShowDelivery] = React.useState(false);
  const [pickupRange, setPickupRange] = React.useState([]);
  const [sPickup, setSPickup] = React.useState(null);
  const [sPSlot, setSPSlot] = React.useState(null);
  const [deliveryRange, setDeliveryRange] = React.useState([]);
  const [sDelivery, setSDelivery] = React.useState(null);
  const [sDSlot, setSDSlot] = React.useState(null);
  const [cLoading, setCLoading] = React.useState(false);
  const [code, setCode] = React.useState(coupon?.coupon?.code ?? "");
  const [items, setItems] = React.useState([]);
  const [services, setServices] = React.useState([]);
  const [weekDaysOff, setWeekDaysOff] = React.useState(null);
  const [open, setOpen] = React.useState({});
  const [order, setOrder] = React.useState(null);
  const [dateInit, setDateInit] = React.useState(true);
  const [couponError, setCouponError] = React.useState(false);

  const params = useParams();
  const setNote = (e) => {
    dispatch({ type: "setNote", payload: e });
  };

  const FilterRange = useCallback(
    (range) => {
      return range.filter((date) => {
        const day = format(date, "EEEE").toLowerCase();
        const dateStringFormatted = format(date, "yyyy-MM-dd");

        return (
          !weekDaysOff?.weekdaysOff.includes(day) &&
          !weekDaysOff?.offDays.includes(dateStringFormatted)
        );
      });
    },
    [weekDaysOff]
  );

  React.useEffect(() => {
    setLoading(true);
    if (params?.id)
      fetchAdminOrderDetails(params?.id).then(
        (res) => {
          const data = res.data;
          // console.log(`coupon data`,data);
          if (data) {
            setOrder(data);
            setDeliveryType(data.delivery_type);
            if (!pickupDate)
              dispatch({
                type: "setPickupDate",
                payload: {
                  slot: data.laundry_pickup_time_slots,
                  date: data.order_pickup_time_slot_date,
                },
              });
            if (!deliveryDate)
              dispatch({
                type: "setDeliveryDate",
                payload: {
                  slot: data.laundry_delivery_time_slots,
                  date: data.order_delivery_time_slot_date,
                },
              });
            if (!addresses)
              dispatch({
                type: "setAddresses",
                payload: {
                  pickup_coordinates: {
                    longitude: data.pickup_coordinates?.coordinates?.[0],
                    latitude: data.pickup_coordinates?.coordinates?.[1],
                  },
                  destination_coordinates: {
                    longitude: data.destination_coordinates?.coordinates?.[0],
                    latitude: data.destination_coordinates?.coordinates?.[1],
                  },
                  pickup_address: {
                    ...data.pickup_address,
                  },
                  destination_address: {
                    ...data.destination_address,
                  },
                },
              });
            if (!coupon) setCode(data?.coupon_code);
          }
        },
        (er) => {
          console.warn(er);
          toast.error("Something went wrong while fetching order details.");
        }
      );
  }, [params]);
  React.useEffect(() => {
    if (code && order) {
      checkCoupon();
    }
  }, [order]);

  React.useEffect(() => {
    if (!cart || (cart && cart.length <= 0)) {
      navigate("/store/orders", { replace: true });
    }
  }, [cart, navigate]);
  React.useEffect(() => {
    fetchWeekDaysOff(orderTypeId).then(
      (res) => setWeekDaysOff(res),
      () => toast.error("Something went wrong!")
    );
  }, [orderTypeId]);

  React.useEffect(() => {
    if (weekDaysOff) {
      if (deliveryType) {
        if (pickupDate?.date && pickupDate?.slot) {
          var sd = addDays(
            /^\d{4}-\d{2}-\d{2}$/.test(pickupDate?.date)
              ? parse(pickupDate?.date, "yyyy-MM-dd", "2024-09-02T00:00:00")
              : pickupDate?.date,
            deliveryType?.pickup_duration
          );
          const ed = addDays(sd, deliveryType?.noOf_calender_dates - 1);
          const dif = FilterRange(eachDayOfInterval({ start: sd, end: ed }));
          setSPickup(
            /^\d{4}-\d{2}-\d{2}$/.test(pickupDate?.date)
              ? parse(pickupDate?.date, "yyyy-MM-dd", "2024-09-02T00:00:00")
              : pickupDate?.date
          );
          setSPSlot(pickupDate?.slot);
          setPickupRange(dif);
          if (!/^\d{4}-\d{2}-\d{2}$/.test(pickupDate?.date) && !dateInit) {
            setTimeout(() => {
              dispatch({ type: "setDeliveryDate", payload: null });
              setSDelivery(null);
              setSDSlot(null);
            }, 100);
          } else if (dateInit) setDateInit(false);
        }
      }
    }
  }, [pickupDate, weekDaysOff, deliveryType]);
  React.useEffect(() => {
    if (weekDaysOff) {
      if (sPickup && deliveryType) {
        let skip = deliveryTypes.find((x) => x.id == orderTypeId)?.duration;
        if (orderTypeId != 1 && orderTypeId != 2) {
          const serv = services.find((x) => x.id == items[0]?.services_id);
          if (serv)
            skip =
              bookingType == 1 ? serv.regular_duration : serv.express_duration;
        }

        const sd = addDays(sPickup, skip);
        const ed = addDays(sd, (deliveryType?.noOf_calender_dates || 15) - 1);
        const dif = FilterRange(eachDayOfInterval({ start: sd, end: ed }));
        if (deliveryDate?.date && deliveryDate?.slot) {
          setSDelivery(
            /^\d{4}-\d{2}-\d{2}$/.test(deliveryDate?.date)
              ? parse(deliveryDate?.date, "yyyy-MM-dd", "2024-09-02T00:00:00")
              : deliveryDate?.date
          );
          setSDSlot(deliveryDate?.slot);
        }
        setDeliveryRange(dif);
      }
    }
  }, [sPickup, deliveryType, deliveryDate, weekDaysOff, FilterRange]);

  const HandlePickupChange = (e) => {
    if (["confirmed", "pending"].includes(order?.order_status)) {
      setSPickup(e.date);
      setSPSlot(e.slot);
      dispatch({ type: "setPickupDate", payload: e });
      setShowPickup(false);
    } else {
      toast.error("You cannot edit Pickup Date.");
    }
  };
  const HandleDeliveryChange = (e) => {
    if (
      !["out_for_delivery", "delivered", "cancelled", "failed"].includes(
        order?.order_status
      )
    ) {
      setSDelivery(e.date);
      setSDSlot(e.slot);
      dispatch({ type: "setDeliveryDate", payload: e });
      setShowDelivery(false);
    } else toast.error("You cannot edit Delivery Date.");
  };
  const checkCoupon = (c = undefined) => {
    const value = (c || code || "").trim();
    if (value !== "" && !cLoading) {
      if (order && value === order?.coupon_code) {
        setCouponError(false);
        dispatch({
          type: "setCoupon",
          payload: {
            code: order?.coupon_code,
            discountAmount: Number(order?.discount_amount || 0),
          },
        });
        return;
      }
      setCLoading(true);
      fetchCoupon({
        code,
        amount,
        zone_id: order?.zone_id,
        user_id: order?.customer?.id,
      }).then(
        (res) => {
          setCouponError(false);
          setCLoading(false);
          // dispatch({ type: "setCoupon", payload: res.coupon });
          dispatch({ 
            type: "setCoupon", 
            payload: {
              ...res.coupon,
              discountAmount: Number(res.discountAmount || 0),
            },
          });
        },
        (err) => {
          if (err) {
            if (code?.trim() === order?.coupon_code) {
              setCouponError(true);
            }
            err?.errors?.forEach((er) => {
              toast.error(er.message);
            });
            dispatch({ type: "setCoupon", payload: null });
          }
          setCLoading(false);
        }
      );
    }
  };
  const RemoveCoupon = () => {
    if (coupon) {
      setCouponError(false);
      dispatch({ type: "setCoupon", payload: null });
      setCode("");
    }
  };
  React.useEffect(() => {
    setLoading(true);
    console.log("orderTypeId", orderTypeId);
    console.log("orderTypes", deliveryTypes);
    const dt = deliveryTypes.find((x) => x.id == orderTypeId);
    setDeliveryType(dt);
    fetchServices(50, 1, orderTypeId).then(
      (res) => {
        setServices(res);
      },
      (err) => console.warn(err, "err while fetching services...")
    );
  }, [deliveryTypes, orderTypeId]);
  React.useEffect(() => {
    if (services.length !== 0 && cart.length !== 0) {
      setLoading(true);
      const temp = cart.reduce((result, item) => {
        const key = item.serviceId;
        setOpen((prev) => ({
          ...prev,
          [key]: true,
        }));
        if (!result[key]) {
          result[key] = {
            services_id: key,
            service: services.find((s) => s.id === key)?.name,
            open: true,
            items: [],
          };
        }
        const {
          laundry_item_id,
          price,
          quantity,
          bar_code,
          name,
          addons,
          is_bundle_active,
          bundle_free,
          free_items,
          bundle_buy,
          item_note,
        } = item;
        result[key].items.push({
          laundry_item_id,
          price,
          quantity,
          bar_code,
          name,
          addons,
          is_bundle_active,
          bundle_free,
          free_items,
          bundle_buy,
          item_note,
        });
        return result;
      }, {});
      const tempTemp = Object.values(temp);
      const anotherTemp = [];
      for (let i = 0; i < tempTemp.length; i++) {
        const x = tempTemp[i];
        anotherTemp.push(x);
      }
      setItems(anotherTemp);
      setLoading(false);
    }
  }, [cart, services]);

  // React.useEffect(() => {
  // dispatch(setCoupon({ discountAmount: order.discount_amount }));
  // return () => dispatch(clearCoupon()); // cleanup on unmount
  // }, [order.discount_amount]);

  React.useEffect(() => {
    if (!order) return;
  dispatch({
  type: "setCoupon",
  payload: {
    ...(JSON.parse(localStorage.getItem("coupon")) || {}),
    code: order?.coupon_code,
    discountAmount: Number(order?.discount_amount || 0),
  },
  });
  // return () => dispatch({ type: "setCoupon", payload: null });
  }, [order]);

  console.log("order.discount_amount", order?.discount_amount);
  console.log("Coupon Redux", useSelector(s => s.Coupon));

  const hasAppliedDiscount = Number(
  useSelector((s) => s.Coupon)?.discountAmount || 0
  ) > 0;

  return (
    <>
      <TitleHeader
        title={"Order Summary"}
        subtitle={
          "Review your order details and get ready for a fresh, clean wardrobe!"
        }
      />
      <div className="container">
        <div className="row justify-content-center py-4">
          <div className="col-xl-6 col-lg-7 col-md-10 col-12">
            {/* Pricing Details */}
            {loading ? (
              <div className="w-100 text-center py-3">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                <OrderSummaryItems
                  items={items}
                  open={open}
                  setOpen={setOpen}
                />
                <div className="card  mb-3">
                  {deliveryTypes ? (
                    <TotalPriceCard deliveryType={deliveryTypes[orderTypeId]}
                    referralPercent={Number(order?.referral_reward?.reward_amount ?? 0)}  />
                  ) : null}
                </div>
                {/* Coupon */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">
                      Apply Coupon
                    </span>
                    <div className="input-group" style={{ height: "44px" }}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Coupon Code"
                        value={code}
                        onChange={(e) => {
                          setCouponError(false);
                          setCode(e.target.value);
                        }}
                      />
                      <button
                        className={`btn text-white fw-semibold ${
                          // coupon ? "btn-danger" : "btn-primary"
                          hasAppliedDiscount ? "btn-danger" : "btn-primary"
                        }`}
                        type="button"
                        onClick={() => {
                          // if (coupon) RemoveCoupon();
                          if (hasAppliedDiscount) RemoveCoupon();
                          else checkCoupon();
                        }}
                        disabled={cLoading}
                      >
                        {cLoading ? (
                          <Spinner variant="white" size="sm" />
                        // ) : coupon ? (
                        ) : hasAppliedDiscount ? (
                          "Remove"
                        ) : (
                          "Apply"
                        )}
                      </button>
                    </div>
                    {couponError ? (
                      <small className="text-danger ms-1">
                        {code} coupon was removed due to inapplicability.
                      </small>
                    ) : null}
                  </div>
                </div>
                {/* Address */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">Address</span>
                    <div className="row">
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-circle-dot"
                          style={{ color: "#32b6e9" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Pickup Address</h6>
                        <p className="m-0">
                          {addresses?.pickup_address
                            ? `${addresses?.pickup_address?.addressLine1}, ${addresses?.pickup_address?.addressLine2}, ${addresses?.pickup_address?.area}, ${addresses?.pickup_address?.area_phase}`
                            : "Select address"}
                        </p>
                        <hr style={{ borderStyle: "doted" }} />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-location-dot text-primary"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Delivery Address</h6>
                        <p className="m-0">
                          {addresses?.destination_address
                            ? `${addresses?.destination_address?.addressLine1}, ${addresses?.destination_address?.addressLine2}, ${addresses?.destination_address?.area}, ${addresses?.destination_address?.area_phase}`
                            : "Select address"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Date pickers */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">
                      Schedule Dates
                    </span>

                    <div className="app-dates-container border border-gray rounded mt-4 py-2 py-md-0">
                      <div className="col-12 col-md-5 px-4">
                        <small
                          style={{ position: "absolute", top: "-12px" }}
                          className="bg-white px-2"
                        >
                          Pickup
                        </small>
                        <div
                          className="d-flex align-items-center py-3 border-r border-gray cursor-pointer"
                          onClick={() => setShowPickup(true)}
                        >
                          <i
                            className="fa-regular fa-calendar-plus me-3"
                            style={{ fontSize: "22px", color: "#666" }}
                          ></i>
                          {sPickup ? format(sPickup, "eee, do MMM") : "Date"}
                          {sPSlot && sPickup ? <br /> : "/"}
                          {sPSlot
                            ? `${sPSlot?.start_time} - ${sPSlot?.end_time}`
                            : "Time"}
                        </div>
                      </div>
                      <div className="col-1 d-none d-md-block border-start border-gray h-100 py-2 border-2">
                        &nbsp;
                      </div>
                      <hr className="w-100 my-2 d-block d-md-none" />
                      <div className="col-12 col-md-5 px-4">
                        <small
                          style={{ position: "absolute" }}
                          className={`bg-white px-2 app-dates-delivery-label ${
                            !sPickup && !sPSlot ? "alt" : ""
                          }`}
                        >
                          Delivery
                        </small>
                        <div
                          className="d-flex align-items-center py-3 cursor-pointer"
                          onClick={() => {
                            if (sPickup && sPSlot) setShowDelivery(true);
                            else
                              toast.error(
                                "Please select pickup_address date & slot first..."
                              );
                          }}
                        >
                          <i
                            className="fa-regular fa-calendar-plus me-3"
                            style={{ fontSize: "22px", color: "#666" }}
                          ></i>
                          {sDelivery
                            ? format(sDelivery, "eee, do MMM")
                            : "Date"}
                          {sDSlot && sDelivery ? <br /> : "/"}
                          {sDSlot
                            ? `${sDSlot?.start_time} - ${sDSlot?.end_time}`
                            : "Time"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Note */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">
                      Order Note / Instructions
                    </span>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                    ></textarea>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="container-fluid bg-white">
        <div
          className="row justify-content-center"
          style={{ padding: "20px 0px" }}
        >
          <div
            className="d-flex col-lg-6 col-md-7 col-12 justify-content-center"
            style={{ columnGap: "20px" }}
          >
            <div
              className="service-btn cart"
              onClick={() => {
                navigate(-1);
              }}
            >
              Back
            </div>
            {/* { deliveryDate && pickupDate ? (
              <Link className="service-btn next" to="/order-review">
                Next
              </Link>
            ) : ( */}
            <button
              className="service-btn next"
              onClick={() => {
                if (!deliveryDate || !pickupDate) {
                  toast.error(
                    "Please select pickup & delivery dates to continue."
                  );
                  return;
                }
                if (deliveryDate && pickupDate) {
                  navigate(`/admin/orders/review/${order.id}`);
                }
              }}
            >
              Next
            </button>
            {/* )} */}
          </div>
        </div>
      </div>
      {order ? (
        <>
          {/* Pickup date modal*/}
          <Modal
            show={showPickup}
            backdrop="static"
            keyboard={false}
            centered
            onHide={() => setShowPickup(false)}
          >
            <Modal.Header closeButton className="py-2">
              <Modal.Title style={{ fontSize: "18px" }}>
                Choose Preferred Date / Time
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {showPickup ? (
                <DatePicker
                  range={pickupRange}
                  selected={sPickup}
                  onChange={HandlePickupChange}
                  orderType={bookingType}
                  timeSlot={sPSlot}
                  type={1}
                  zone={order.zone_id}
                />
              ) : null}
            </Modal.Body>
          </Modal>
          {/* delivery date modal*/}
          <Modal
            show={showDelivery}
            backdrop="static"
            keyboard={false}
            centered
            onHide={() => setShowDelivery(false)}
          >
            <Modal.Header closeButton className="py-2">
              <Modal.Title style={{ fontSize: "18px" }}>
                Choose Preferred Date / Time
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {showDelivery ? (
                <DatePicker
                  range={deliveryRange}
                  selected={sDelivery}
                  onChange={HandleDeliveryChange}
                  orderType={bookingType}
                  timeSlot={sDSlot}
                  pickup={{
                    date: sPickup ? format(sPickup, "yyyy-MM-dd") : null,
                    slotId: sPSlot.id,
                  }}
                  type={2}
                  zone={order.zone_id}
                />
              ) : null}
            </Modal.Body>
          </Modal>
        </>
      ) : null}
    </>
  );
};
